import React from 'react'
import { HorizontalStack, ShowOnlyOnScreenSize } from '@ztechapps/webui.util'
import { Col, Row } from 'react-bootstrap'
import { TopActions } from './TopActions'
import { ProgressBar } from './progress/ProgressBar'

export const ActionAndProgress = () => {
  return (
    <div>
      <HorizontalStack className={'justify-content-between'}>
        <div>
          <ShowOnlyOnScreenSize size="desktop">
            <Row>
              <Col md={12}>
                <ProgressBar />
              </Col>
            </Row>
          </ShowOnlyOnScreenSize>
        </div>
        <TopActions />
      </HorizontalStack>
    </div>
  )
}
